import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setIsResizingPageElement } from 'crazyEditor/redux/modules/stage/stage';
import styles from '../shared/PageResizeStyles';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { KNOB_DIRECTIONS } from 'crazyEditor/core/constants/editorConstants';
import { CustomSvgIcon } from 'crazyEditor/components/EditorUI/BaseUI/index';
import FloatingActionButton from 'material-ui/FloatingActionButton';

const pageHeightResizeIconPath = 'M13,17h3l-4,4L8,17h3V7H8l4-4,4,4H13V17Z';

@connect(
  false,
  {
    setIsResizingPageElement
  }
)
@Radium
export default class HeightPageResize extends Component {
  constructor(props) {
    super(props);

    this.onMouseDown = this.onMouseDown.bind(this);
  }

  onMouseDown(event) {
    const { setIsResizingPageElement } = this.props;
    setIsResizingPageElement(true, KNOB_DIRECTIONS.BOTTOM_MIDDLE);
    event.stopPropagation();
  }

  getPosition() {
    const { spacingFromPageElement, stageLayout } = this.props;
    return {
      top: stageLayout.height + spacingFromPageElement,
      marginLeft: -styles.button.width / 2,
      left: '50%'
    };
  }

  render() {
    return (
      <div style={[styles.buttonWrapper, this.getPosition()]} onMouseDown={this.onMouseDown}>
        <button style={[styles.button, {cursor: 'ns-resize'}]}>
          <CustomSvgIcon path={pageHeightResizeIconPath} color="#9e9e9e"/>
        </button>
      </div>
    );
  }
}

HeightPageResize.propTypes = {
  stageLayout: PropTypes.object.isRequired,
  spacingFromPageElement: PropTypes.number.isRequired
};